import Tooltip from "react-tooltip";
import { Disclosure } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";
import CheckBoxesField from "./CheckBoxesField";
import {
  PermissionChanged,
  PermissionFieldList,
  UpdateRoleField,
} from "../types";
import { useRecoilState } from "recoil";
import { formDirty } from "../Atoms/atoms";

export default function PermissionField(props: {
  data;
  index: number;
  id: number;
  roleData: UpdateRoleField[];
  setRoleData: React.Dispatch<React.SetStateAction<UpdateRoleField[]>>;
}) {
  const { data, index, id, roleData, setRoleData } = props;
  const [operation, setOperation] = useState("");
  const [checkAllAccess, setCheckAllAccess] = useState(Boolean);
  const [listField, setListField] = useState<PermissionFieldList[]>([]);
  const [oldData, setOldData] = useState<PermissionFieldList[]>([]);

  const [dirty, setDirty] = useRecoilState(formDirty);

  const AllAccess = (value: boolean) => {
    setDirty(true);
    let y = [...listField];
    let updatedRoleData = [...roleData];

    y.forEach((permission, index) => {
      if (value === true) {
        permission.access = true;
      } else {
        permission.access = false;
      }
      let accessPermId =
        data.groupedPermissions[index].permissions["access"]?.permissionId;
      if (accessPermId) {
        const existingIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === accessPermId
        );
        if (existingIndex !== -1) {
          updatedRoleData[existingIndex].status = value;
        } else {
          updatedRoleData.push({
            id: id,
            permissionId: accessPermId,
            status: value,
          });
        }
      }
      updatedRoleData = updatedRoleData.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.permissionId === item.permissionId)
      );
    });
    setCheckAllAccess(value);
    setListField(y);
    setRoleData(updatedRoleData);
  };

  useEffect(() => {
    let y: any[] = [];

    data.groupedPermissions.forEach((subModule) => {
      let access;
      let permissionId;

      if (subModule.permissions.access !== null) {
        access = subModule.permissions.access.status;
        permissionId = subModule.permissions.access.permissionId;
      }
      y.push({ access, permissionId });
    });
    setListField([...y]);
    if (oldData.length === 0) setOldData(y);
    DATAReady([...y]);
  }, [oldData]);

  const Selected = (
    value: boolean,
    index: number,
    sign: string,
    permissionId?: number
  ) => {
    setDirty(true);
    let y = [...listField];
    let updatedRoleData = [...roleData];
    const accessPermissionId =
      permissionId ||
      data.groupedPermissions[index].permissions["access"]?.permissionId;
    let datos: UpdateRoleField = {
      id: id,
      permissionId: accessPermissionId || 1,
      status: value,
    };

    updatedRoleData.push({
      ...datos,
      permissionId: accessPermissionId,
      status: datos.status,
    });

    if (sign === "access") {
      y[index].access = value;

      if (y.every((permission) => permission.access === true)) {
        setCheckAllAccess(true);
      } else {
        setCheckAllAccess(false);
      }
    }

    const uniqueRoleData = updatedRoleData.reduceRight((acc, item) => {
      if (!acc.some((i) => i.permissionId === item.permissionId)) {
        acc.unshift(item);
      }
      return acc;
    }, [] as UpdateRoleField[]);

    setListField(y);
    setRoleData(uniqueRoleData);
  };

  const DATAReady = (listField: any[]) => {
    const access = listField.every((permission) => permission.access === true);
    if (access) {
      setCheckAllAccess(true);
    } else {
      setCheckAllAccess(false);
    }
  };
  return (
    <div>
      <Disclosure key={index} defaultOpen={true}>
        {({ open }) => (
          <>
            <>
              <Disclosure.Button className="disclosureBtn my-1 flex justify-start w-full  py-2  text-sm font-medium text-left">
                {open ? (
                  <MinusIcon className="text-gray-500 p-px bg-gray-300 rounded-sm  w-3 h-3" />
                ) : (
                  <PlusIcon className="text-gray-500 p-px bg-gray-300 rounded-sm  w-3 h-3" />
                )}
                <div>
                  {" "}
                  <span className="text-quinary font-bold text-sm ml-2">
                    {data.name}
                  </span>
                </div>
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 py-2 text-sm bg-gray-50 text-gray-500 shadow-md">
                <div className="grid grid-cols-6 text-center pb-2 disclosureLabel pl-2">
                  <div>Permission Name</div>
                  <div>
                    <input
                      type="checkbox"
                      className="text-center h-5 w-5 mr-2"
                      checked={checkAllAccess}
                      onChange={(e) => {
                        AllAccess(e.target.checked);
                      }}
                      data-tip="all"
                    />
                    <Tooltip
                      effect="solid"
                      type="info"
                      border={true}
                      arrowColor="white"
                      borderColor="#0078d7"
                      backgroundColor="white"
                      textColor="#0078d7"
                    />
                    Access
                  </div>
                </div>

                {data.groupedPermissions.map((permission, i) => (
                  <>
                    {" "}
                    <div className="grid grid-cols-6 text-center">
                      <div className="font-bold text-primary border-b border-gray-200 py-1">
                        {permission.moduleName}
                      </div>
                      <div className=" text-center border-b border-gray-200 pt-2 pr-11 ">
                        {permission.permissions?.access &&
                          listField.length > 0 && (
                            <div>
                              <CheckBoxesField
                                data={listField}
                                value={operation}
                                range={"access"}
                                setOperation={setOperation}
                                selected={Selected}
                                index={i}
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  </>
                ))}
              </Disclosure.Panel>
            </>
          </>
        )}
      </Disclosure>
    </div>
  );
}
